import React from 'react';
import { Check, Shield, BookOpen, Clock, Star, AlertCircle, ChevronDown, Lock } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
// Image URLs
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/6qrrKJBNLbZo3x9zPgBFbW/PROYECTOS_Anuales_(5).png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/innVMTkTCmJ4eQoJahCdgb/31.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/4HkkRvsjcK6FDMmMdQETVT/32.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/2qUaHoCzFsrqL3YNug2J72/33.png';
const BONUS_4_IMAGE = 'https://cdn.magicpatterns.com/uploads/e9fHiiPS7Dog4VGPUckNpr/34.png';
const BONUS_5_IMAGE = 'https://cdn.magicpatterns.com/uploads/uzUyoxyGB6KMJwCNr53DN1/35.png';
export function LandingPage() {
  const checkoutUrl = 'https://checkout9.edulabs.online/cart/46345244049539:1';
  const testimonials = [{
    name: 'María González',
    role: 'Profesora de Matemática',
    location: 'Buenos Aires',
    age: 42,
    content: 'Antes pasaba horas buscando material. Ahora tengo todo organizado y mis clases son mucho más efectivas. Mis estudiantes notan la diferencia.'
  }, {
    name: 'Carlos Ramírez',
    role: 'Docente Secundaria',
    location: 'Madrid',
    age: 35,
    content: 'Lo mejor es que puedo adaptar el material a mis grupos sin partir de cero. Me ahorra al menos 8 horas semanales de planificación.'
  }, {
    name: 'Ana Martínez',
    role: 'Profesora Matemática',
    location: 'México DF',
    age: 38,
    content: 'Finalmente puedo cubrir todo el programa sin estrés. El material está tan bien explicado que mis alumnos entienden a la primera.'
  }, {
    name: 'Roberto Silva',
    role: 'Docente Bachillerato',
    location: 'Bogotá',
    age: 45,
    content: 'Llevo 20 años enseñando y este es el recurso más completo que he usado. Las evaluaciones son excelentes y me facilitan mucho la corrección.'
  }, {
    name: 'Laura Fernández',
    role: 'Profesora ESO',
    location: 'Santiago',
    age: 31,
    content: 'Como docente joven, necesitaba estructura y confianza. Este pack me dio ambas cosas. Ahora disfruto más enseñar.'
  }];
  const faqs = [{
    q: '¿El material es digital o físico?',
    a: 'Es 100% digital. Recibís acceso inmediato a todo el material para descargar y usar cuando quieras.'
  }, {
    q: '¿Sirve para todos los niveles de Educación Media?',
    a: 'Sí, cubre desde 1° a 6° año de Educación Media (Secundaria / Bachillerato / ESO).'
  }, {
    q: '¿Puedo usarlo en clases presenciales y virtuales?',
    a: 'Absolutamente. El material está diseñado para adaptarse a cualquier modalidad de enseñanza.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'El acceso es de por vida. Una vez que comprás, el material es tuyo para siempre.'
  }, {
    q: '¿Es seguro comprar?',
    a: 'Totalmente. Usamos una plataforma de pagos encriptada y segura. Tus datos están protegidos.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés una garantía de 7 días. Si no estás conforme, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-21">
      <PurchasePopup data-id="element-22" />

      {/* Hero Section */}
      <header className="bg-white text-gray-900 pt-6 pb-6 px-4 text-center" data-id="element-23">
        <div className="max-w-4xl mx-auto" data-id="element-24">
          <div className="inline-block bg-blue-100 px-6 py-2 rounded-full mb-3" data-id="element-25">
            <p className="text-blue-700 font-bold tracking-wider uppercase text-sm md:text-base" data-id="element-26">
              Para docentes de Matemática
            </p>
          </div>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-3 leading-tight text-gray-900 px-2" data-id="element-27">
            ORGANIZÁ TODO TU AÑO DE MATEMÁTICA{' '}
            <span className="text-blue-600" data-id="element-28">SIN ESTRÉS</span>
          </h1>

          <div className="mb-3 transform hover:scale-105 transition-transform duration-500" data-id="element-29">
            <a href={checkoutUrl} data-id="element-30">
              <img src={MAIN_IMAGE} alt="MegaPack Matemática LISTA - Colección completa de libros y recursos" className="mx-auto max-w-full w-80 md:w-96 drop-shadow-2xl" data-id="element-31" />
            </a>
          </div>

          <h2 className="text-base md:text-lg text-gray-700 mb-4 max-w-3xl mx-auto px-2" data-id="element-32">
            Todo tu año de Matemática resuelto. Material listo para usar para
            Educación Media (Secundaria · Bachillerato · ESO)
          </h2>

          <div className="flex flex-col items-center gap-3" data-id="element-33">
            <CTAButton text="QUIERO ACCESO INMEDIATO" className="text-lg md:text-xl px-8 py-4" scrollToPurchase={true} data-id="element-34" />
            <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-35">
              <Lock className="w-3 h-3" data-id="element-36" />
              <span data-id="element-37">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-blue-50/50" data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <div className="bg-orange-50 border-l-4 border-orange-500 p-6 md:p-8 rounded-r-lg mb-12" data-id="element-40">
            <h3 className="text-2xl font-bold text-orange-800 mb-4" data-id="element-41">
              Si enseñás Matemática, esto te va a sonar muy familiar…
            </h3>
            <p className="text-gray-700 text-lg mb-4" data-id="element-42">
              Llegás cansado/a. Sabés que tenés que planificar. Abrís la
              computadora. Y otra vez empezás de cero.
            </p>
            <p className="text-gray-700 text-lg mb-4" data-id="element-43">
              Buscando ejercicios. Buscando problemas que se entiendan. Buscando
              actividades. Buscando evaluaciones. Buscando cómo explicar sin
              confundir.
            </p>
            <p className="text-gray-700 text-lg font-medium" data-id="element-44">
              Y el tiempo vuela. Y el cansancio crece. Y tu cabeza no para.
            </p>
          </div>

          <div className="text-center mb-12" data-id="element-45">
            <p className="text-xl text-gray-800" data-id="element-46">
              No porque no sepas enseñar. No porque no seas buen docente.{' '}
              <br className="hidden md:block" data-id="element-47" />
              <span className="font-bold text-blue-600" data-id="element-48">
                Sino porque estás intentando sostener todo el año sin un sistema
                que te sostenga a vos.
              </span>
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 text-center shadow-sm border border-gray-100" data-id="element-49">
            <h3 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-50">
              El problema real
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-51">
              {['Planificar', 'Preparar actividades', 'Armar evaluaciones', 'Cumplir programas', 'Nivelar grupos', 'Motivar estudiantes', 'Registrar avances'].map(item => <div key={item} className="bg-gray-50 p-3 rounded-lg shadow-sm border border-gray-200 text-sm font-medium text-gray-600 flex items-center justify-center h-full" data-id="element-52">
                  {item}
                </div>)}
              <div className="bg-red-100 p-3 rounded-lg border border-red-200 text-sm font-bold text-red-600 flex items-center justify-center" data-id="element-53">
                Todo al mismo tiempo
              </div>
            </div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-54">
              Y nadie te dio un sistema completo para hacerlo sin agotarte.
            </p>
            <p className="text-xl font-medium text-gray-800 italic" data-id="element-55">
              Vivís improvisando, llevando trabajo a casa, corriendo detrás del
              programa y sintiendo que nunca terminás.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-20 px-4 bg-blue-50/50 text-gray-900 text-center" data-id="element-56">
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <h2 className="text-yellow-600 font-bold tracking-widest uppercase mb-4" data-id="element-58">
            LA SOLUCIÓN DEFINITIVA
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold mb-8 text-gray-900" data-id="element-59">
            MEGAPACK MATEMÁTICA LISTA™
          </h3>
          <p className="text-xl md:text-2xl text-gray-700 mb-12" data-id="element-60">
            Un sistema completo de Matemática organizado por año para Educación
            Media.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12" data-id="element-61">
            {['Todo listo', 'Todo probado', 'Todo ordenado', 'Todo usable'].map(item => <div key={item} className="flex flex-col items-center gap-3" data-id="element-62">
                  <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center text-white shadow-lg" data-id="element-63">
                    <Check className="w-6 h-6" data-id="element-64" />
                  </div>
                  <span className="font-bold text-lg" data-id="element-65">{item}</span>
                </div>)}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4 bg-white" data-id="element-66">
        <div className="max-w-5xl mx-auto" data-id="element-67">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-68">
            ¿Qué incluye el Megapack?
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-69">
            <div className="order-2 md:order-1" data-id="element-70">
              <ul className="space-y-4" data-id="element-71">
                {['6 cuadernillos completos (1° a 6° año)', 'Teoría clara explicada paso a paso', 'Ejercicios resueltos', 'Actividades prácticas', 'Evaluaciones y diagnósticos', 'Secuencias por unidad', 'Material visual', 'Planillas docentes'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-72">
                    <div className="mt-1 min-w-[20px]" data-id="element-73">
                      <Check className="w-5 h-5 text-green-500" data-id="element-74" />
                    </div>
                    <span className="text-lg text-gray-700" data-id="element-75">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="order-1 md:order-2 bg-blue-50/50 p-6 rounded-2xl border border-blue-100" data-id="element-76">
              <img src={MAIN_IMAGE} alt="Contenido del MegaPack" className="w-full h-auto drop-shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-77" />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-16 px-4 bg-blue-50/50" data-id="element-78">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-79">
          {/* Student Benefits */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-80">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-6" data-id="element-81">
              <BookOpen className="w-6 h-6" data-id="element-82" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-83">
              Qué logran tus estudiantes
            </h3>
            <ul className="space-y-3" data-id="element-84">
              {['Comprender Matemática paso a paso', 'Resolver con más seguridad', 'Participar más en clase', 'Reducir la frustración', 'Mejorar su rendimiento'].map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-85">
                  <div className="w-2 h-2 rounded-full bg-blue-600" data-id="element-86"></div>
                  <span className="text-gray-700" data-id="element-87">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Teacher Benefits */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-88">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-6" data-id="element-89">
              <Clock className="w-6 h-6" data-id="element-90" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-91">
              Qué ganás vos
            </h3>
            <ul className="space-y-3" data-id="element-92">
              {['Ahorrar hasta 10 horas semanales', 'Dejar de improvisar', 'Cubrir todo el programa', 'Enseñar con claridad', 'Volver a disfrutar enseñar'].map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-93">
                  <div className="w-2 h-2 rounded-full bg-blue-600" data-id="element-94"></div>
                  <span className="text-gray-700" data-id="element-95">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-96">
          <CTAButton text="QUIERO LOGRAR ESTO" scrollToPurchase={true} data-id="element-97" />
          <div className="mt-4 flex justify-center items-center gap-2 text-sm text-gray-500" data-id="element-98">
            <Lock className="w-4 h-4" data-id="element-99" />
            <span data-id="element-100">Pago 100% seguro y encriptado</span>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-blue-50/50 text-gray-900" data-id="element-101">
        <div className="max-w-6xl mx-auto" data-id="element-102">
          <div className="text-center mb-16" data-id="element-103">
            <span className="bg-yellow-400 text-blue-900 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-4 inline-block" data-id="element-104">
              Oferta Especial
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-105">
              BONOS INCLUIDOS — GRATIS HOY
            </h2>
            <p className="text-xl text-gray-700" data-id="element-106">
              Llevate todo esto de regalo con tu compra
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-107">
            {/* Bonus 1 */}
            <a href={checkoutUrl} className="group" data-id="element-108">
              <div className="bg-white rounded-xl p-4 border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all h-full flex flex-col" data-id="element-109">
                <div className="relative mb-4" data-id="element-110">
                  <img src={BONUS_1_IMAGE} alt="Kit Premium de Evaluaciones" className="w-full rounded-lg shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-111" />
                  <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md transform rotate-3" data-id="element-112">
                    GRATIS HOY
                  </div>
                </div>
                <h3 className="font-bold text-xl text-blue-600 mb-2" data-id="element-113">
                  BONO 1 – Kit Premium de Evaluaciones
                </h3>
                <p className="text-sm text-gray-600" data-id="element-114">
                  +50 evaluaciones listas con criterios de corrección
                </p>
              </div>
            </a>

            {/* Bonus 2 */}
            <a href={checkoutUrl} className="group" data-id="element-115">
              <div className="bg-white rounded-xl p-4 border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all h-full flex flex-col" data-id="element-116">
                <div className="relative mb-4" data-id="element-117">
                  <img src={BONUS_2_IMAGE} alt="Banco de Juegos" className="w-full rounded-lg shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-118" />
                  <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md transform rotate-3" data-id="element-119">
                    GRATIS HOY
                  </div>
                </div>
                <h3 className="font-bold text-xl text-blue-600 mb-2" data-id="element-120">
                  BONO 2 – Banco de Juegos y Actividades
                </h3>
                <p className="text-sm text-gray-600" data-id="element-121">
                  +30 recursos lúdicos para motivar tus clases
                </p>
              </div>
            </a>

            {/* Bonus 3 */}
            <a href={checkoutUrl} className="group" data-id="element-122">
              <div className="bg-white rounded-xl p-4 border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all h-full flex flex-col" data-id="element-123">
                <div className="relative mb-4" data-id="element-124">
                  <img src={BONUS_3_IMAGE} alt="Plantillas de Planificación" className="w-full rounded-lg shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-125" />
                  <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md transform rotate-3" data-id="element-126">
                    GRATIS HOY
                  </div>
                </div>
                <h3 className="font-bold text-xl text-blue-600 mb-2" data-id="element-127">
                  BONO 3 – Plantillas Profesionales
                </h3>
                <p className="text-sm text-gray-600" data-id="element-128">
                  Modelos semanales y mensuales listos para organizar tu año
                </p>
              </div>
            </a>

            {/* Bonus 4 */}
            <a href={checkoutUrl} className="group" data-id="element-129">
              <div className="bg-white rounded-xl p-4 border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all h-full flex flex-col" data-id="element-130">
                <div className="relative mb-4" data-id="element-131">
                  <img src={BONUS_4_IMAGE} alt="Carpeta de Recursos" className="w-full rounded-lg shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-132" />
                  <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md transform rotate-3" data-id="element-133">
                    GRATIS HOY
                  </div>
                </div>
                <h3 className="font-bold text-xl text-blue-600 mb-2" data-id="element-134">
                  BONO 4 – Carpeta de Recursos por Áreas
                </h3>
                <p className="text-sm text-gray-600" data-id="element-135">
                  Álgebra, Aritmética, Geometría, Trigonometría y Pensamiento
                  Lógico
                </p>
              </div>
            </a>
          </div>

          {/* Bonus 5 */}
          <a href={checkoutUrl} className="group block max-w-md mx-auto" data-id="element-136">
            <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-blue-300 hover:shadow-lg transition-all text-center" data-id="element-137">
              <div className="relative mb-4" data-id="element-138">
                <img src={BONUS_5_IMAGE} alt="Colección Resolvamos Problemas" className="w-full rounded-lg shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-139" />
                <div className="absolute -top-3 -right-3 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md transform rotate-3" data-id="element-140">
                  GRATIS HOY
                </div>
              </div>
              <h3 className="font-bold text-2xl text-blue-600 mb-2" data-id="element-141">
                BONO 5 – Colección "Resolvamos Problemas"
              </h3>
              <p className="text-lg text-gray-700" data-id="element-142">
                5 cuadernos con fichas prácticas por competencias
              </p>
            </div>
          </a>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="purchase-section" className="py-20 px-4 bg-white relative overflow-hidden scroll-mt-20" data-id="element-143">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-145">
            ACCESO COMPLETO DE POR VIDA
          </h2>

          <div className="bg-white rounded-3xl shadow-2xl border-2 border-blue-100 p-8 md:p-12 max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300" data-id="element-146">
            <div className="mb-6" data-id="element-147">
              <span className="text-gray-400 text-2xl line-through font-medium block mb-2" data-id="element-148">
                $49.99 USD
              </span>
              <div className="flex items-center justify-center gap-3" data-id="element-149">
                <span className="text-6xl font-extrabold text-blue-600" data-id="element-150">
                  $13.99
                </span>
                <span className="text-2xl font-bold text-gray-600" data-id="element-151">USD</span>
              </div>
              <div className="mt-4 inline-block bg-green-100 text-green-700 font-bold px-4 py-1 rounded-full text-sm" data-id="element-152">
                Precio de Lanzamiento
              </div>
              <p className="text-sm text-gray-500 mt-3" data-id="element-153">
                *Pagarás en la moneda de tu país
              </p>
            </div>

            <div className="space-y-4 mb-8 text-left max-w-xs mx-auto" data-id="element-154">
              {['Descarga inmediata', 'Acceso ilimitado', 'Garantía de 7 días'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-155">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-156" />
                  <span className="text-gray-700 font-medium" data-id="element-157">{item}</span>
                </div>)}
            </div>

            <CTAButton text="SI, QUIERO EL MEGAPACK" fullWidth className="text-xl py-5 mb-4" data-id="element-158" />

            <p className="text-xs text-gray-500" data-id="element-159">
              Pago único. Sin suscripciones. Acceso de por vida.
            </p>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-blue-50/50" data-id="element-160">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-200 flex flex-col md:flex-row items-center gap-8" data-id="element-161">
          <div className="flex-shrink-0" data-id="element-162">
            <Shield className="w-24 h-24 text-blue-600" data-id="element-163" />
          </div>
          <div data-id="element-164">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-165">
              Garantía sin vueltas
            </h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-166">
              Probalo 7 días. Si no te sirve, te devolvemos el 100% de tu
              dinero.
            </p>
            <p className="text-sm text-gray-500" data-id="element-167">
              Sin preguntas, sin letra chica. Queremos que estés 100% conforme.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-white" data-id="element-168">
        <div className="max-w-6xl mx-auto" data-id="element-169">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-170">
            Lo que dicen otros docentes
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-171">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-172" />)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-blue-50/50" data-id="element-173">
        <div className="max-w-3xl mx-auto" data-id="element-174">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-175">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="space-y-4" data-id="element-176">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-177">
                <h3 className="font-bold text-lg text-gray-900 mb-2 flex items-start gap-3" data-id="element-178">
                  <span className="text-blue-600 mt-1" data-id="element-179">
                    <AlertCircle className="w-5 h-5" data-id="element-180" />
                  </span>
                  {faq.q}
                </h3>
                <p className="text-gray-600 ml-8" data-id="element-181">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Guarantee Before Final CTA */}
      <section className="py-16 px-4 bg-white" data-id="element-182">
        <div className="max-w-2xl mx-auto text-center" data-id="element-183">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6" data-id="element-184">
            <Shield className="w-10 h-10 text-blue-600" data-id="element-185" />
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-186">
            Garantía de 7 Días
          </h3>
          <p className="text-lg text-gray-700 mb-6" data-id="element-187">
            Si el MegaPack no cumple tus expectativas, te devolvemos el{' '}
            <span className="font-bold text-blue-600" data-id="element-188">100% de tu dinero</span>{' '}
            sin hacer preguntas.
          </p>
          <p className="text-gray-600 mb-8" data-id="element-189">
            Queremos que estés completamente satisfecho con tu compra. Probá el
            material durante 7 días completos y si no te convence, te
            reembolsamos todo.
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-blue-50/50 text-gray-900 text-center" data-id="element-190">
        <div className="max-w-4xl mx-auto" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-192">
            ¿Listo para transformar tu año escolar?
          </h2>
          <div className="flex flex-col items-center gap-6" data-id="element-193">
            <CTAButton text="QUIERO EMPEZAR AHORA" className="text-xl px-12 py-6" scrollToPurchase={true} data-id="element-194" />
            <p className="text-xl font-medium text-gray-700" data-id="element-195">
              MegaPack Matemática LISTA™
            </p>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-196">
        <div className="max-w-6xl mx-auto" data-id="element-197">
          <p data-id="element-198">
            &copy; {new Date().getFullYear()} MegaPack Matemática LISTA™. Todos
            los derechos reservados.
          </p>
          <p className="mt-2" data-id="element-199">
            Este sitio no es parte de Facebook o Facebook Inc. Además, este
            sitio no está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>
    </div>;
}